/// <amd-module name="CodeCoverage/CodeCoverageCiFileCoveragePane/CodeEditorGutterAdornments/CodeCoverageAdornmentProvider" />
import { GutterAdornment } from "CodeCoverage/CodeCoverageCiFileCoveragePane/CodeEditorGutterAdornments/AdornmentContracts";
import * as Resources from "CodeCoverage/CodeCoverageCiFileCoveragePane/Resources";
import { FileCoverageDetails } from "CodeCoverage/Clients/Coverage/Contracts/Coverage";
import { getCoverageClient } from "CodeCoverage/Clients/Coverage/RestClient/Coverage";
import { IVssPageContext } from "VSS/Platform/Context";

export interface ICodeCoverageFileContext {
    /**
     * Path of the specified file
     */
    path: string;
    /**
     * Coverage scope
     */
    scope: string;
}

export class CodeCoverageAdornmentProvider {
    private adornmentCount: number = 0;

    constructor(private pageContext: IVssPageContext) {}

    public getGutterAdornments(
        codeCoverageFileContext: ICodeCoverageFileContext,
        projectId: string,
        pipelineId: number
    ): Promise<Array<GutterAdornment>> {
        const coverageClient = getCoverageClient(this.pageContext);
        return coverageClient.getFileCoverageDetails(codeCoverageFileContext, projectId, pipelineId).then((fileCoverageData: FileCoverageDetails) => {
            return this.mapGutterAdornments(fileCoverageData);
        });
    }

    private createAdornmentBlock(lineRange: Array<string>, className: string, helpText: string): Array<GutterAdornment> {
        let adorn: GutterAdornment;
        const adornmentCollection: Array<GutterAdornment> = [];
        let lineNumbers: Array<string>;

        lineRange.map(value => {
            lineNumbers = value.split("-");
            let end: number;

            end = lineNumbers.length > 1 ? parseInt(lineNumbers[1]) + 1 : parseInt(lineNumbers[0]) + 1;

            adorn = {
                id: this.adornmentCount++,
                startLine: parseInt(lineNumbers[0]),
                endLine: end,
                className: className,
                showLineNumber: true,
                helpText: helpText
            };

            adornmentCollection.push(adorn);
        });

        return adornmentCollection;
    }

    private mapGutterAdornments(fileCoverageDataText: FileCoverageDetails): Promise<Array<GutterAdornment>> {
        let coveredAdornments: Array<GutterAdornment> = [];
        let notCoveredAdornments: Array<GutterAdornment> = [];
        let partiallyCoveredAdornments: Array<GutterAdornment> = [];

        if (fileCoverageDataText.covered) {
            const covered = fileCoverageDataText.covered.split(",");
            coveredAdornments = this.createAdornmentBlock(
                covered,
                "gutter-adornment padding-right-4 scroll-hidden succeeded",
                Resources.CoveredLinesHelpText
            );
        }

        if (fileCoverageDataText.notCovered) {
            const notCovered = fileCoverageDataText.notCovered.split(",");
            notCoveredAdornments = this.createAdornmentBlock(
                notCovered,
                "gutter-adornment padding-right-4 scroll-hidden failed",
                Resources.NotCoveredLinesHelpText
            );
        }

        if (fileCoverageDataText.partiallyCovered) {
            const partiallyCovered = fileCoverageDataText.partiallyCovered.split(",");
            partiallyCoveredAdornments = this.createAdornmentBlock(
                partiallyCovered,
                "gutter-adornment padding-right-4 scroll-hidden warning",
                Resources.PartiallyCoveredLinesHelpText
            );
        }

        const adornments = coveredAdornments.concat(notCoveredAdornments, partiallyCoveredAdornments);

        return Promise.resolve(adornments);
    }
}
